import { ISubtaskItemMoq } from '../../models/subtaskItemMoq.model';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_SUBTASK_ITEM_MOQ,
  CREATE_MULTIPLE_SUBTASK_ITEM_MOQ_LIST,
  CREATE_SUBTASK_ITEM_MOQ_LIST,
  FETCH_SUBTASK_ITEM_MOQ_LIST,
} from './subtaskItemMoq.actions';
import { SubtaskItemMoqState } from './subtaskItemMoq.types';

const initialState: SubtaskItemMoqState = {
  errorMessage: '',
  item: {} as Readonly<ISubtaskItemMoq>,
  items: [] as ISubtaskItemMoq[],
  loading: false,
  totalItems: 0,
};

export default (
  state: SubtaskItemMoqState = initialState,
  action: AppAction,
): SubtaskItemMoqState => {
  switch (action.type) {
    case REQUEST(FETCH_SUBTASK_ITEM_MOQ_LIST):
    case REQUEST(CREATE_SUBTASK_ITEM_MOQ_LIST):
    case REQUEST(CREATE_MULTIPLE_SUBTASK_ITEM_MOQ_LIST):
      return { ...state, loading: true };
    case SUCCESS(CREATE_SUBTASK_ITEM_MOQ_LIST):
    case FAILURE(CREATE_SUBTASK_ITEM_MOQ_LIST):
    case SUCCESS(CREATE_MULTIPLE_SUBTASK_ITEM_MOQ_LIST):
      return {
        ...state,
        loading: false,
      };
    case SUCCESS(FETCH_SUBTASK_ITEM_MOQ_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_SUBTASK_ITEM_MOQ_LIST):
    case FAILURE(CREATE_MULTIPLE_SUBTASK_ITEM_MOQ_LIST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case CLEAR_SUBTASK_ITEM_MOQ:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
